import { render, staticRenderFns } from "./TableListProducts.vue?vue&type=template&id=69ba45fc&scoped=true&"
import script from "./TableListProducts.vue?vue&type=script&lang=js&"
export * from "./TableListProducts.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=69ba45fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ba45fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69ba45fc')) {
      api.createRecord('69ba45fc', component.options)
    } else {
      api.reload('69ba45fc', component.options)
    }
    module.hot.accept("./TableListProducts.vue?vue&type=template&id=69ba45fc&scoped=true&", function () {
      api.rerender('69ba45fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/TableListProducts.vue"
export default component.exports